import React, { forwardRef } from "react";

import Courses from "../forms/Courses";

const StaffCourses = forwardRef((props, ref) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Courses />
    </div>
  );
});

export default StaffCourses;
